import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, nextTick } from "vue"
  import { storeToRefs } from "pinia"
  import { ACarregamentoCalendario } from "@/components/Gerais"

  import "vue-cal/dist/vuecal.css"
  import "vue-cal/dist/i18n/es.cjs"
  import "vue-cal/dist/i18n/pt-br.cjs"

  import { OEvento } from ".."
  import VueCal, { EventReadyChanged } from "vue-cal"

  import { usarListarAtividadesStore } from "@/store/atividades/ListarAtividades/ListarAtividades.store"

  import { ModeloEventoCalendario } from "@/store/atividades"
  import { usarIdiomaDoNavegador } from "@/composable/UsarIdiomaDoNavegador/usarIdiomaDoNavegador"

  interface Props {
    selectedDate: Date
    activeView: string
    estaCarregando: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCalendario',
  props: {
    selectedDate: null,
    activeView: null,
    estaCarregando: { type: Boolean }
  },
  emits: ["onExibirDetalhesAtividade", "update:selectedDate", "update:activeView", "onMudarPeriodo", "onCalendarioPronto"],
  setup(__props: any, { expose, emit: emitir }: { emit: ({
    (event: "onExibirDetalhesAtividade", evento: ModeloEventoCalendario)
    (event: "update:selectedDate", selectedDate: Date): void
    (event: "update:activeView", activeView: string): void
    (event: "onMudarPeriodo", evento: EventReadyChanged)
    (event: "onCalendarioPronto", evento: any)
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selectedDate: Date
    activeView: string
    estaCarregando: boolean
  }

  
  

  const { definirIdiomaDoCalendario } = usarIdiomaDoNavegador()

  const vuecalRef = ref<typeof VueCal>(null)
  const ALTURA_DAS_LINHAS = 56

  const modoDeVisualizacao = computed({
    get() {
      return props.activeView
    },
    set(activeView: string) {
      emitir("update:activeView", activeView)
    },
  })
  const dataAtual = computed({
    get() {
      return props.selectedDate
    },
    set(selectedDate: Date) {
      emitir("update:selectedDate", selectedDate)
    },
  })
  const emitirCalendarioCarregado = (evento: EventReadyChanged): void => {
    emitir("onCalendarioPronto", evento)
    irParaHorarioAtual()
  }
  const emitirMudarPeriodo = async (
    evento: EventReadyChanged
  ): Promise<void> => {
    emitir("onMudarPeriodo", evento)
    setTimeout(() => {
      irParaHorarioAtual()
    }, 1000)
  }
  const onCliqueAtividade = (evento: ModeloEventoCalendario): void => {
    emitir("onExibirDetalhesAtividade", evento)
  }

  const { atividades } = storeToRefs(usarListarAtividadesStore())

  const anterior = (): void => {
    vuecalRef.value.previous()
  }
  const proxima = (): void => {
    vuecalRef.value.next()
  }
  const hoje = (): void => {
    vuecalRef.value.switchView(modoDeVisualizacao.value, new Date())
    irParaHorarioAtual()
  }

  const irParaHorarioAtual = async (): Promise<void> => {
    await nextTick()
    const calendario = vuecalRef.value.$el.querySelector(".vuecal__bg")
    const horas = new Date().getHours() + new Date().getMinutes() / 60
    if ("scrollTo" in calendario) {
      calendario.scrollTo({
        top: horas * ALTURA_DAS_LINHAS * 2,
        behavior: "smooth",
      })
    }
  }

  expose({
    anterior,
    proxima,
    hoje,
    vuecalRef,
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ACarregamentoCalendario), { "esta-carregando-calendario": __props.estaCarregando }, {
    default: _withCtx(() => [
      _createVNode(_unref(VueCal), {
        "active-view": _unref(modoDeVisualizacao),
        "onUpdate:active-view": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modoDeVisualizacao) ? (modoDeVisualizacao).value = $event : null)),
        "selected-date": _unref(dataAtual),
        "onUpdate:selected-date": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dataAtual) ? (dataAtual).value = $event : null)),
        onReady: emitirCalendarioCarregado,
        onViewChange: emitirMudarPeriodo,
        ref_key: "vuecalRef",
        ref: vuecalRef,
        class: "OCalendario",
        "data-testid": "OCalendario",
        "disable-views": [],
        events: _unref(atividades),
        "hide-title-bar": "",
        "hide-view-selector": "",
        locale: _unref(definirIdiomaDoCalendario)(),
        "min-event-height": 50,
        "min-event-width": 50,
        "on-event-click": onCliqueAtividade,
        "overlaps-per-time-step": false,
        "resize-x": "",
        "time-cell-height": ALTURA_DAS_LINHAS,
        "time-from": 0 * 60,
        "time-step": 30,
        "time-to": 24 * 60,
        "watch-real-time": ""
      }, {
        event: _withCtx(({ event }) => [
          _createVNode(_unref(OEvento), {
            id: event.id,
            "data-testid": "OCalendario__Evento",
            "fase-da-atividade": event.faseDaAtividade,
            fim: new Date(event.end),
            icone: event.icone,
            "id-usuario-criador": event?.idUsuarioCriador,
            inicio: new Date(event.start),
            "modo-de-registro-fim": event.modoDeRegistroFim,
            "modo-de-registro-inicio": event.modoDeRegistroInicio,
            problemas: event.problemas,
            profissionais: event.profissionais,
            status: event.status,
            "tipo-de-atividade": event.tipoDeAtividade.nome
          }, null, 8, ["id", "fase-da-atividade", "fim", "icone", "id-usuario-criador", "inicio", "modo-de-registro-fim", "modo-de-registro-inicio", "problemas", "profissionais", "status", "tipo-de-atividade"])
        ]),
        _: 1
      }, 8, ["active-view", "selected-date", "events", "locale"])
    ]),
    _: 1
  }, 8, ["esta-carregando-calendario"]))
}
}

})